export default __webpack_public_path__ + "static/media/usdc.f7fd5286.png";